import { render } from "./StockComponent.vue?vue&type=template&id=01e9175c"
import script from "./StockComponent.vue?vue&type=script&lang=js"
export * from "./StockComponent.vue?vue&type=script&lang=js"

import "./StockComponent.vue?vue&type=style&index=0&id=01e9175c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__